var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.kioskDatas, null, 2)))])}
var staticRenderFns = []

export { render, staticRenderFns }